export default {
    signedInUsersCount: state => {
        return state.signedInUsersCount;
    },

    globalConfig: state => {
        return state.globalcfg;
    },

    maxFilesize: state => {
        return state.globalcfg.maxFileSize;
    },

    invite: state => {
        return state.invite;
    },

    redirectInfo: state => {
        return state.redirectInfo;
    },

    reloadUI: state => {
        return state.reloadUI === 'RELOAD' ? true : undefined;
    },

    roles: state => {
        return state.roles;
    }
};
